module.exports = __webpack_public_path__ + "static/media/kn95.5eb7f55a.png";